module.exports = __webpack_public_path__ + "static/media/banner-partner.8cb694b1.png";